webpackJsonp([151841215545449],{

/***/ 411:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "",
				"timeToRead": 1,
				"excerpt": "",
				"frontmatter": {
					"title": "Introduction to CAAML",
					"cover": null,
					"date": null,
					"category": null,
					"tags": null
				}
			},
			"tableOfContents": {
				"chapters": [
					{
						"title": "1. Introduction",
						"entries": null,
						"chapters": [
							{
								"title": "1.1 OGC Standards",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_ogc.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-ogc"
												},
												"frontmatter": {
													"title": "Introduction to OGC"
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "1.1.1 Web Mapping Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wms.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wms"
														},
														"frontmatter": {
															"title": "Introduction to WMS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wms.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wms-examples"
														},
														"frontmatter": {
															"title": "WMS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.2 Web Feature Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wfs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wfs"
														},
														"frontmatter": {
															"title": "Introduction to WFS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wfs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wfs-examples"
														},
														"frontmatter": {
															"title": "WFS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.3 Web Coverage Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wcs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wcs"
														},
														"frontmatter": {
															"title": "Introduction to WCS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wcs.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wcs-examples"
														},
														"frontmatter": {
															"title": "WCS Examples"
														}
													}
												}
											}
										]
									},
									{
										"title": "1.1.4 Web Processing Service",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_wps.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/introduction-to-wps"
														},
														"frontmatter": {
															"title": "Introduction to WPS"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/examples_wps.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/wps-examples"
														},
														"frontmatter": {
															"title": "WPS Examples"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "1.2 CAAML",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_caaml.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-caaml"
												},
												"frontmatter": {
													"title": "Introduction to CAAML"
												}
											}
										}
									}
								],
								"chapters": null
							},
							{
								"title": "1.3 INSPIRE",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_inspire.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/introduction-to-inspire"
												},
												"frontmatter": {
													"title": "Introduction to INSPIRE"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "2. Standards in action",
						"entries": null,
						"chapters": [
							{
								"title": "2.1 Prepare data and toolkit",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/intro_data_tools.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/data-and-geospatial-tools"
												},
												"frontmatter": {
													"title": "Data and geospatial tools"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/bootstrap_servers.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/start-the-environment"
												},
												"frontmatter": {
													"title": "Start the environment"
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "2.1.1 Manage the data",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/load-data"
														},
														"frontmatter": {
															"title": "Load Data"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/clean_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/clean-data"
														},
														"frontmatter": {
															"title": "Clean Data"
														}
													}
												}
											}
										]
									},
									{
										"title": "2.1.2 Design the CAAML schema",
										"entries": [
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/er_design.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/caaml-model-design"
														},
														"frontmatter": {
															"title": "CAAML model design"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/populate_data.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/populate-region"
														},
														"frontmatter": {
															"title": "Populate Region"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "2.2 Build CAAML with GeoAvalanche",
								"entries": [
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/caaml_hale.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/configure-the-application-schema-for-caaml"
												},
												"frontmatter": {
													"title": "Configure the application schema for CAAML"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/load_configuration.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/push-the-configuration-to-geo-avalanche"
												},
												"frontmatter": {
													"title": "Push the configuration to GeoAvalanche"
												}
											}
										}
									},
									{
										"entry": {
											"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/query_data.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/query-our-region-features"
												},
												"frontmatter": {
													"title": "Query our Region features"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "3. Main Chapter",
						"entries": [
							{
								"entry": {
									"id": "/Users/geobart/code/GeoAvalanche/ogc-caaml-inspire/content/lessons/lesson_six.md absPath of file",
									"childMarkdownRemark": {
										"fields": {
											"slug": "/lesson-six"
										},
										"frontmatter": {
											"title": "Lesson Six"
										}
									}
								}
							}
						],
						"chapters": null
					}
				]
			}
		},
		"pathContext": {
			"slug": "/introduction-to-caaml"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---introduction-to-caaml-e2046ceaf42bc1333a15.js